import { socketStateContext, useNakamaSocket } from "../../hooks/useNakama"

export function NakamaSocketProvider({ children }: { children: React.ReactNode }) {
  const data = useNakamaSocket()
  return <socketStateContext.Provider value={data}>{children}</socketStateContext.Provider>
}
